import { MDCList } from '@material/list';
import { MDCMenu } from '@material/menu';
import { Corner } from '@material/menu-surface/constants';
import {MDCSnackbar} from '@material/snackbar';

import moment from 'moment';
import $ from 'jquery';

moment.locale("pt-BR");

$(document).ready(function () {

	let cMenu = document.querySelector('#candidates-menu')
	if(cMenu){
		cMenu = new MDCMenu(cMenu);
		cMenu.setAnchorCorner(Corner.BOTTOM_START);
		$("#candidates-menu-button").on('click', () => { cMenu.open = true; });
	}

	let aMenu = document.querySelector('#about-menu')
	if(aMenu){
		aMenu = new MDCMenu(aMenu);
		aMenu.setAnchorCorner(Corner.BOTTOM_START);
		$("#about-menu-button").on('click', () => { aMenu.open = true; });
	}

	let lMenu = document.querySelector('#login-menu')
	if(lMenu){
		lMenu = new MDCMenu(lMenu);
		lMenu.setAnchorCorner(Corner.BOTTOM_START);
		$("#login-menu-button").on('click', () => { lMenu.open = true; });
	}

	document.querySelectorAll('.mdc-snackbar').forEach(s => {
		const snackbar = new MDCSnackbar(s);
		snackbar.open();
	});

	// const drawer = MDCList.attachTo(document.querySelector('.drawer-main-menu'));
	// drawer.wrapFocus = true;
});

